import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "../../styles/login.css";
import "../../styles/centralised-plan/layouts.css";
import { loginEndPoint } from "../../data/ApiEndpoints";
import { useCreateFetch } from "../../data/Queries";
import { login, logout } from "../../redux/reducers/authSlice";
import { selectIsAuth, selectToken, selectUser } from "./auth.selector";
import HelmetWrapper from "../../HelmetWrapper";
import LoginPage from "../login/LoginPage";
import { loginSchema } from "../../schema/authSchema";

const Login = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const previousPath = location?.state?.from;

  const isAuthenticated = useSelector(selectIsAuth);
  const token = useSelector(selectToken);
  const userInfoData = useSelector(selectUser);

  // const [previousPath, setPreviousPath] = useState(location?.state?.from || "");

  const { mutateAsync: loginUser, isLoading: isLoadingLogin } = useCreateFetch({
    key: "login",
    token: "",
    url: loginEndPoint,
  });

  const formik = useFormik({
    initialValues: {
      username: "",
      password: "",
      is_dashboard: 1,
    },
    validationSchema: loginSchema,
    onSubmit: handleSubmit,
  });

  async function handleSubmit(val) {
    try {
      const { status, message, data } = await loginUser(val);

      if (status) {
        // Check if user is a member
        if (data?.account_type === "member") {
          toast.error("Members do not have access to the dashboard.");
          return;
        }
        
        dispatch(login(data));
        toast.success(message ? message : "Success!");
      } else {
        toast.error(message ? message : "Server Error!");
      }
    } catch (error) {
      console.log(error);
    }
  }

  const handleLogout = () => {
    navigate("/login", { state: { from: location?.state?.from } });
    dispatch(logout());
  };

  // useEffect(() => {
  //   if (isAuthenticated && token) {
  //     const allFeatures = userInfoData?.features || [];

  //     if (previousPath) {
  //       navigate(previousPath, { replace: true });
  //     } else if (allFeatures.length > 0) {
  //       const firstPath = allFeatures[0]?.sub_menu?.[0]?.path || "/";
  //       navigate(firstPath, { replace: true });
  //     } else {
  //       navigate("/", { replace: true });
  //     }
  //   } else {
  //     handleLogout();
  //   }
  // }, [token, isAuthenticated, userInfoData]);

  useEffect(() => {
    if (isAuthenticated && token) {
      const allFeatures = userInfoData?.features || [];

      const validPaths = allFeatures?.flatMap(
        (feature) => feature?.sub_menu?.map((menu) => menu?.path) || []
      );

      console.log("validPaths=> ", validPaths);

      if (previousPath && validPaths?.includes(previousPath)) {
        navigate(previousPath, { replace: true });
      } else if (validPaths.length > 0) {
        navigate(validPaths[0], { replace: true });
      } else {
        navigate("/", { replace: true });
      }
    } else if (!isAuthenticated) {
      handleLogout();
    }
  }, [token, isAuthenticated, userInfoData]);

  // useEffect(() => {
  //   if (isAuthenticated && token) {
  //     const allFeatures = userInfoData?.features || [];

  //     if (allFeatures.length > 0) {
  //       const firstPath =
  //         location?.state?.from?.pathname ||
  //         allFeatures[0]?.sub_menu?.[0]?.path ||
  //         "/";

  //       navigate(firstPath, { replace: true });
  //     } else {
  //       navigate("/", { replace: true });
  //     }
  //   } else {
  //     try {
  //       dispatch(logout());
  //       navigate("/login", { replace: true });
  //     } catch (error) {
  //       console.log(error);
  //     }
  //   }
  // }, [token, isAuthenticated, userInfoData]);

  return (
    <HelmetWrapper title="WTF: Login">
      <LoginPage formik={formik} isLoadingLogin={isLoadingLogin} />
    </HelmetWrapper>
  );
};

export default Login;
